<template>
  <b-card-group deck>
    <b-link @click="clickHandler('PP_One_Site')">
      <b-card
        bg-variant="info  "
        text-variant="white"
        header="PayPoint One"
        class="text-center card"
      >
        <b-card-text>I want to access my PayPoint One Account</b-card-text>
      </b-card>
    </b-link>
    <b-link @click="clickHandler('PP_Mini_Site')">
      <b-card
        bg-variant="info"
        text-variant="white"
        header="PayPoint Mini"
        class="text-center card"
      >
        <b-card-text>I want to access my PayPoint Mini Account</b-card-text>
      </b-card>
    </b-link>
  </b-card-group>
</template>

<script>
export default {
  name: "DeviceChoice",
  components: {},
  props: {
    displayAccountChoice: {
      type: Boolean,
    },
    clickHandler: {
      type: Function,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.card-deck {
  flex-flow: inherit;
  width: 100%;
  justify-content: center;
}
.container {
  display: flex;
  justify-content: space-around;
}
.choice {
  border: 1px solid #e9d369;
  padding: 10px;
}

.card:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.06);
}

//override the card colours
.bg-info {
  background-color: #fbd21d !important;
}
.text-white {
  color: #000 !important;
}
</style>
